var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"animated-logo",staticClass:"animated-logo-title"})
}
var staticRenderFns = []

export { render, staticRenderFns }